import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './Pages/Index';
import Staking from './Pages/Staking';
import DAO from './Pages/Dao';
import Proposalcreate from './Pages/Proposalcreate';
import Vote from './Pages/Vote';

import './App.css';
import './responsive.css';
// Web 3 React For Wallet Connection
import { Web3ReactProvider } from "@web3-react/core";
import { ethers } from "ethers"

export const getLibrary = (provider) => {
  const library = new ethers.providers.Web3Provider(provider)
  library.pollingInterval = 8000 // Frequency provider is polling
  return library
};

function App() {
  return (
    <>
      <Web3ReactProvider getLibrary={getLibrary}>
        <Router>
          <Routes>
            <Route path='/' exact element={<Home />} />
            <Route path='/dao' element={<DAO />} />
            <Route path='/staking' element={<Staking />} />
            <Route path='/proposal-create' element={<Proposalcreate />} />
            <Route path='/vote' element={<Vote />} />

          </Routes>
        </Router>
      </Web3ReactProvider>
    </>
  );
}

export default App;
